import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm$manager, _vm$manager2, _vm$manager3, _vm$manager4, _vm$manager5, _vm$manager6, _vm$manager7, _vm$manager8, _setup$manual;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.canIHelpYouBanner
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.titleContainer
  }, [_c(_setup.AppTitle, {
    attrs: {
      "title": _vm.$t('needHelp'),
      "semantic-head-level": "3",
      "style-head-level": "2"
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.subtitle
  }, [_vm._v("\n        " + _vm._s(_vm.$t('subtitle')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.infoContainer
  }, [_c('div', {
    class: _vm.$style.contacts
  }, [_c('div', {
    class: _vm.$style.managerWrapper
  }, [_c('div', {
    class: _vm.$style.profilePicture
  }, [_c(_setup.SImageLazy, {
    class: _vm.$style.bgImage,
    attrs: {
      "src": (_vm$manager = _vm.manager) === null || _vm$manager === void 0 ? void 0 : _vm$manager.photo.aws,
      "alt": "",
      "object-fit": "cover",
      "fade": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: [_setup.YM_HIDE_CONTENT, _vm.$style.name]
  }, [_vm._v("\n              " + _vm._s((_vm$manager2 = _vm.manager) === null || _vm$manager2 === void 0 ? void 0 : _vm$manager2.lastname) + " " + _vm._s((_vm$manager3 = _vm.manager) === null || _vm$manager3 === void 0 ? void 0 : _vm$manager3.name) + "\n            ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.lable
  }, [_vm._v("\n              " + _vm._s((_vm$manager4 = _vm.manager) === null || _vm$manager4 === void 0 ? void 0 : _vm$manager4.position) + "\n            ")])])]), _vm._v(" "), _c('div', {
    class: _vm.$style.contactsInfo
  }, [_c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.lable
  }, [_vm._v("\n              " + _vm._s(_vm.$t('phone')) + "\n            ")]), _vm._v(" "), _setup.isMobile ? _c('a', {
    class: _vm.$style.blockInfo,
    attrs: {
      "href": "tel:".concat((_vm$manager5 = _vm.manager) === null || _vm$manager5 === void 0 ? void 0 : _vm$manager5.phone)
    }
  }, [_c(_setup.PhoneOutput, {
    attrs: {
      "input": (_vm$manager6 = _vm.manager) === null || _vm$manager6 === void 0 ? void 0 : _vm$manager6.phone,
      "without-parenthesis": ""
    }
  })], 1) : _c(_setup.PhoneOutput, {
    class: _vm.$style.blockInfo,
    attrs: {
      "input": (_vm$manager7 = _vm.manager) === null || _vm$manager7 === void 0 ? void 0 : _vm$manager7.phone,
      "without-parenthesis": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.lable
  }, [_vm._v("\n              " + _vm._s(_vm.$t('schedule')) + "\n            ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.blockInfo
  }, [_vm._v("\n              " + _vm._s((_vm$manager8 = _vm.manager) === null || _vm$manager8 === void 0 ? void 0 : _vm$manager8.work_schedule) + "\n            ")])])])])])]), _vm._v(" "), (_setup$manual = _setup.manual) !== null && _setup$manual !== void 0 && _setup$manual.link ? _c('div', {
    class: _vm.$style.instruction
  }, [_c(_setup.Instruction, {
    attrs: {
      "link": _setup.manual.link,
      "text": _vm.$t('instruction')
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };